import React, { Suspense } from 'react';
import { seismicTheme, Theme } from '@seismic/mantle';
import EngagementViewerComponent from '../components/viewerWrapper';
import { initializeMockService, initLanguage } from '../service/index';
import { initApplicationInfo, isMobileDevice } from '../commonUtil/util';
import { LinkContextWrapper } from './reducers';
import { setNewrelicTracer } from '../commonUtil/newrelicTracer';
import { initPresentationViewer } from '../commonUtil/presentationUtil';
import ErrorBoundary from '../components/errorBoundary';
import initCSSVariable from './initCSSVariable';
import { useEventListener, useInitViewPort } from '../commonUtil/hookUtil';

import '../style/style.scss';

export default function EngagementViewer({ imageURL, humanEvent }) {
    initCSSVariable();
    useInitViewPort();
    useEventListener('resize', initCSSVariable);
    initializeMockService();
    initApplicationInfo(imageURL);
    initLanguage();
    setNewrelicTracer();
    initPresentationViewer();

    return (
        <Theme theme={seismicTheme({ useGlobal: false })}>
            <LinkContextWrapper>
                <div className={`engagament-viewer-root ${isMobileDevice.any() ? 'engagement-viewer-mobile-device' : ''}`}>
                    <Suspense fallback={<div className="engagement-viewer-busy-spinner" />}>
                        <ErrorBoundary>
                            <EngagementViewerComponent humanEvent={humanEvent} />
                        </ErrorBoundary>
                    </Suspense>
                </div>
            </LinkContextWrapper>
        </Theme>
    );
}
